export default class SelectedList {
  debug = process.env.VUE_APP_DEV_DOMAIN === "true";

  checkField = "check";

  state = {
    list: [],
    isSelectAll: false,
  };

  constructor({ list, checkField }) {
    this.state.list = list;
    this.checkField = checkField;
  }

  updateList(list) {
    this.state.list = list;
  }

  //改变选中
  selected(item, status) {
    if (this.debug) console.log("改变购物车选择状态", item, status);
    item[this.checkField] = status;

    this.calcIsSelectAll();
  }

  //更新全选状态
  calcIsSelectAll() {
    if (this.debug) console.log("更新全选状态");
    let checkAll = true;
    this.state.list.forEach((item) => {
      checkAll = checkAll && item[this.checkField];
    });

    this.state.isSelectAll = checkAll;
  }

  //选中所有
  selectedAll(status) {
    if (this.debug) console.log("改变全选状态", status);
    this.state.isSelectAll = status;
    this.state.list.forEach((item) => {
      item[this.checkField] = this.state.isSelectAll;
    });
  }

  //删除选中
  deleteSelectedItems() {
    if (this.debug) console.log("删除选中");
    let { list } = this.state;

    list
      .filter((it) => it[this.checkField])
      .forEach((it) => {
        list.splice(list.indexOf(it), 1);
      });
  }

  getSelected() {
    let { list } = this.state;
    return list.filter((it) => it[this.checkField]);
  }
}
